import { FC } from "react";

import { PanelTopRightWrapperStyled, PanelTopStatReports } from "@ryde/layout";

export const PanelTopRightReports: FC = () => {
  return (
    <PanelTopRightWrapperStyled>
      <PanelTopStatReports />
      {/*    temporarily disabled by RYDE-3958 (until diagrams ready)   <ReportsViewSwitch /> */}
    </PanelTopRightWrapperStyled>
  );
};
